import styled from "styled-components";

export const ProfileWrapperDefaultBox = styled.div`
    margin: 4rem 0 0 0;
    border-radius: 5px;
    background-color: ${({theme}) => theme.colors.background};
`;
